import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import YesNoInput from '../../common/components/yes-no-input'
import Validation from '../../common/modules/validation/rules'
import Alert from '../../common/components/alert'
import QuoteNumber from '../../common/components/quote-number'
import InputField from '../../common/components/input-field'
import { mapValues, pickBy } from 'lodash'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import yesNoOptions from '../../common/options/yes-no-options'
import { get } from 'lodash'
import { toCurrency } from '../../common/util'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData;
    const catastropheCoverAmount = fields.buildingSumInsured * (fields.catastrophePercent/100);
    const selectedState = get(fields, 'ownersCorporationAddress.state')

    return {
        rules:{
            buildingSumInsured:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
                Validation.enforce.greaterThanEqual(0, "Must be a positive value"),
                Validation.enforce.lessThanEqual(250000000, "Must be less than 250000000")
            ],
            contentsSumInsured:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
                Validation.enforce.greaterThanEqual(0, "Must be a positive value"),
                Validation.enforce.lessThanEqual(250000000, "Must be less than 250000000")
            ],
            liabilitySumInsured :[
                Validation.enforce.required("Please select a value"),
            ],
            floodRequested:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
        },
        predicates: {
        },
        transformOut: data => ({
            ...data,
            step: "/step-3"
        }),
        inferred:{
            floodCover: "OPTIONAL", // Hardcoding this, but this field should be coming back from the server. TODO for a future iteration.
        },
        options:{
            floodRequested: yesNoOptions,
            liabilitySumInsured: function(){
                var options = productData.productSumsInsured.Liability;
            // NSW: $20 Million min liability| ACT,SA,QLD,VIC,NT: $10 Million min liability| WA,TAS: $5 Million min liability
                switch (selectedState) {
                    case "NSW": 
                        return options.filter(option => option.value >= 20000000)
                    case "SA":
                    case "QLD":
                    case "VIC":
                    case "NT":
                    case "ACT":
                       return options.filter(option => option.value >= 10000000)
                    case "TAS":
                    case "WA":
                       return options.filter(option => option.value >= 5000000)
                }
            }()
        },
    }
}


@withSubmission
@withState
@withNavigation
@withProductData
@withValidation
@withRouteBlocker
@withFields
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {


    onBlur(field){
        const formData = this.props.form.getData();
        const fields = this.props.fields;
        const rules = formData.rules;

        // When the buildingSumInsured looses focus, check to see that it is a number value and if it is
        // set the next field (contentsSumInsured) to 1% of buildingSumInsured
        if(field === "buildingSumInsured"){
            // Only continue if the buildingSumInsured field passes the following rules
            if(Validation.doesPass(fields.buildingSumInsured, rules.buildingSumInsured)){
                // Only update contentsSumInsured if its current value is invalid
                if(!Validation.doesPass(fields.contentsSumInsured, rules.contentsSumInsured)){
                    this.props.actions.fields.updateField("contentsSumInsured", Math.round(fields.buildingSumInsured * 0.01));
                }
            }
        }
    }



    render() {
       const actions = this.props.actions;
       const formData = this.props.form.getData();
       const predicates = formData.predicates;
       const inferred = formData.inferred;
       const fields = this.props.fields;

       return (
            <div className="row">

                <StepTitle>Tell Us About Your Coverage</StepTitle>
                <QuoteNumber />

                <SubHeader>Your property Cover</SubHeader>
                <StepBlock>Note, these are required by all Australian Strata Living legislation.</StepBlock>
                <InputField   field="buildingSumInsured"                   type="Currency"    inline={ true }        label="How much would you like to insure your building for?" onBlur={ this.onBlur.bind(this) }  help="This is the maximum amount we would pay out for damage to your building or buildings as defined by the Strata Schemes Management Act, Strata titles Act, Community Titles Act or similar legislation applying to where Your building is situated. Read the PDS for more information." />
                <InputField   field="contentsSumInsured"                   type="Currency"    inline={ true }        label="How much would you like to insure the common area contents for?" help="Common Area Contents include shared property such as swimming pool covers, fire extinguishers and garden equipment. Read the PDS for more information." />

                <Alert show={ inferred.floodCover == "REQUIRED" } ><p>Flood cover is included with the policy</p></Alert>
                <Alert show={ inferred.floodCover == "NOT_INCLUDED" } ><p>This policy does not included flood cover</p></Alert>
                
                <InputField    field="floodRequested"                                   type="Boolean"                         label="Would you like flood cover"  show={ () => inferred.floodCover == "OPTIONAL"}   />

                <SubHeader>Your Liability Cover</SubHeader>
                <InputField   field="liabilitySumInsured"                  type="Currency"    inline={ true }        label="How much liability cover would you like?" />
                
                <Button.Container>
                    <Button.Back route="/step-2" /> <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>

            </div>

        )
    }


    onContinue(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.quickQuote
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
        ])
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-4")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-3.tsx